module.exports = __webpack_public_path__ + "media/fonts/lineto-circular-medium-d71f06b9.ttf";